import React, { useEffect, useState } from "react";
import CrudTable from "../components/CrudTable";
import { api } from "../lib/api";

const columns = [
  { key: "ticket_id", label: "Ticket ID" },
  { key: "issue", label: "Issue" },
  { key: "priority", label: "Priority", status: true },
  { key: "status", label: "Status", status: true },
  { key: "visit_date", label: "Visit Date" },
];

export default function Maintenance() {
  const [brands, setBrands] = useState([]);
  const [outlets, setOutlets] = useState([]);
  useEffect(() => {
    api.get("/brands", { params: { limit: 200 } }).then((r) => setBrands(r.data.items));
    api.get("/outlets", { params: { limit: 500 } }).then((r) => setOutlets(r.data.items));
  }, []);
  const formFields = [
    { name: "brand_id", label: "Brand", type: "select", required: true, options: brands.map((b) => ({ value: b.id, label: b.name })) },
    { name: "outlet_id", label: "Outlet", type: "select", required: true, options: outlets.map((o) => ({ value: o.id, label: o.name })) },
    { name: "issue", label: "Issue", required: true, wide: true },
    { name: "priority", label: "Priority", type: "select", default: "medium",
      options: [{ value: "low", label: "Low" }, { value: "medium", label: "Medium" }, { value: "high", label: "High" }, { value: "critical", label: "Critical" }] },
    { name: "status", label: "Status", type: "select", default: "open",
      options: [{ value: "open", label: "Open" }, { value: "assigned", label: "Assigned" }, { value: "in_progress", label: "In Progress" }, { value: "resolved", label: "Resolved" }, { value: "closed", label: "Closed" }] },
    { name: "visit_date", label: "Visit Date", type: "date" },
    { name: "notes", label: "Service Notes", wide: true },
  ];
  return <CrudTable title="Maintenance" description="Track and resolve service tickets end-to-end via RushServ." endpoint="/maintenance" columns={columns} formFields={formFields} />;
}
